module.exports = __webpack_public_path__ + "resources/img/main08.bb59f334281c3738f52bddb5f54d4e7f.png";